import {
  Button,
  Col,
  Container,
  Dropdown,
  FloatingLabel,
  Form,
  Placeholder,
  Row,
} from "react-bootstrap";
import { DropdownFilter, FloatInput, HeadPage } from "src/componentes";
import ProdutoCadastroCode from "./ProdutoCadastro.Code";
import { CategoriasCadastroDto } from "../../Categorias/Cadastro/CategoriasCadastro.Dto";
import { ConsultarCategoria } from "src/hook/Consulta/ConsultaCategoria.Module";
import { useEffect } from "react";

const ProdutoCadastroView = () => {
  const {
    register,
    errors,
    handleSubmit,
    onSubmit,
    loading,
    setValue,
    menuItens,
    handleClickNavigate,
    isDuplicate,
  } = ProdutoCadastroCode();
  const { CategoriaBuscar, loadingCategoria } = ConsultarCategoria();

  useEffect(() => {
    console.log(errors);
  }, [errors]);

  return (
    <Container>
      <Form noValidate onSubmit={handleSubmit(onSubmit)}>
        <HeadPage
          headText={`${
            isDuplicate ? "Produto Duplicando" : "Produto Cadastro"
          }`}
        >
          {menuItens !== undefined &&
            menuItens.map((item) => (
              <Dropdown.Item
                key={item.nome}
                onClick={handleClickNavigate(item.rota)}
              >
                {item.nome}
              </Dropdown.Item>
            ))}
        </HeadPage>
        {!loading ? (
          <>
            <Row>
              <Col xs={12} sm={12} md={3} lg={3}>
                <FloatInput
                  label="Código"
                  errorsMessage={errors.codigoProduto}
                  registerField={register("codigoProduto")}
                  inputMask="capitalizar"
                />
              </Col>
              <Col xs={12} sm={12} md={9} lg={9}>
                <FloatInput
                  label="Nome"
                  errorsMessage={errors.nome}
                  registerField={register("nome")}
                  inputMask="capitalizar"
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={12} md={12} lg={12}>
                <FloatInput
                  label="Descrição"
                  errorsMessage={errors.descricao}
                  registerField={register("descricao")}
                  inputMask="capitalizar"
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={12} md={4} lg={4}>
                <FloatInput
                  label="Valor Unitário Comercial"
                  errorsMessage={errors.valorUnitarioComercial}
                  registerField={register("valorUnitarioComercial")}
                  inputMask="double"
                />
              </Col>
              <Col xs={12} sm={12} md={4} lg={4}>
                <FloatInput
                  label="Unidade Comercial"
                  errorsMessage={errors.unidadeComercial}
                  registerField={register("unidadeComercial")}
                  inputMask="maiusculas"
                />
              </Col>
              <Col xs={12} sm={12} md={4} lg={4}>
                <FloatInput
                  label="Código NCM"
                  errorsMessage={errors.codigoNCM}
                  registerField={register("codigoNCM")}
                  inputMask="int"
                  autoComplete
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={12} md={12} lg={12}>
                <FloatInput
                  label="Código Barras"
                  errorsMessage={errors.codigoBarras}
                  registerField={register("codigoBarras")}
                  inputMask="maiusculas"
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={12} md={12} lg={12}>
                <DropdownFilter<CategoriasCadastroDto>
                  fetchData={CategoriaBuscar}
                  loading={loadingCategoria}
                  labelDescription="Categoria"
                  getDescription={(item: CategoriasCadastroDto) => item.nome}
                  getId={(item: CategoriasCadastroDto) => item.id}
                  registeredFields={{
                    id: register("categoriaId"),
                    description: register("categoriaNome"),
                  }}
                  errorsMessageDescription={errors.categoriaId}
                  onSelect={(item: CategoriasCadastroDto | undefined) => {
                    if (item !== undefined) {
                      setValue("categoriaId", item.id);
                      setValue("categoriaNome", item.nome);
                    } else {
                      setValue("categoriaNome", "");
                    }
                  }}
                ></DropdownFilter>
              </Col>
            </Row>
            <Row>
              <Col xs={12} className="d-grid mt-3 mb-5">
                <Button type="submit">Confirmar</Button>
              </Col>
            </Row>
          </>
        ) : (
          <Placeholder as={FloatingLabel} animation="glow">
            <Placeholder xs={12} />
          </Placeholder>
        )}
      </Form>
    </Container>
  );
};

export default ProdutoCadastroView;
